import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { HttpClient } from '@angular/common/http';
import { RecurringJob } from '../models/recurring-job';
import { HangfireJob } from '../models/hangfire-job';

@Injectable({
  providedIn: 'root'
})
export class HangfireBeheerService {
  constructor(
    private http: HttpClient,
    private appConfigSvc: AppConfigService
  ) {}

  load() {
    return this.http.get<HangfireJob[]>(
      this.appConfigSvc.getConfig().apiRoot + '/HangfireBeheer'
    );
  }

  beschikbareTaken() {
    return this.http.get<string[]>(
      this.appConfigSvc.getConfig().apiRoot + '/HangfireBeheer/BeschikbareTaken'
    );
  }

  toevoegenTaak(hj: HangfireJob) {
    return this.http.post(
      this.appConfigSvc.getConfig().apiRoot + '/HangfireBeheer',
      hj
    );
  }

  verwijderenTaak(hj: HangfireJob) {
    return this.http.delete(
      this.appConfigSvc.getConfig().apiRoot + '/HangfireBeheer/' + hj.id
    );
  }
}
